import { Component, OnDestroy } from '@angular/core';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { NbTokenService } from '@nebular/auth';
import { NbMenuItem } from '@nebular/theme';
import { PagesMenu } from './pages-menu';
import { InitUserService } from '../@theme/services/init-user.service';
import { DialogTemplateComponent } from './miscellaneous/dialog-template/dialog-template.component';
import { ChatService } from './chat/chat.service';

//Adicionar ao template abaixo: <ngx-chat-window></ngx-chat-window>

@Component({
    selector: 'ngx-pages',
    styleUrls: ['pages.component.scss'],
    template: `
        <ngx-one-column-layout>
            <nb-menu [items]="menu"></nb-menu>      
            <router-outlet></router-outlet>            
        </ngx-one-column-layout> 
    `,
})
export class PagesComponent implements OnDestroy {
    [x: string]: any;

    menu: NbMenuItem[];
    alive: boolean = true;

    constructor(
        private pagesMenu: PagesMenu,
        private tokenService: NbTokenService,
        protected initUserService: InitUserService,
        private chatService: ChatService,
        ) {
        this.initMenu();
        this.tokenService
            .tokenChange()
            .pipe(takeWhile(() => this.alive))
            .subscribe(async () => {
                this.initMenu();
                await this.chatInit(true);
            });
    }

    initMenu() {
        this.pagesMenu.getMenu2()
            .pipe(takeWhile(() => this.alive))
            .subscribe(menu => {
                this.menu = menu;
            });
    }

    async ngOnDestroy() {
        await this.chatInit(false);
        this.alive = false;
    }

    sendInviteProvider() {
        this.dialogService.open(DialogTemplateComponent)
            .onClose.subscribe(stausConfirm => {
                if (stausConfirm === true) {

                }
            });
    }

    private async chatInit(state: boolean) {
        if (state) {
            await this.chatService.init();
        } else {
            //await this.chatService.doLeave();
        }
    }
}
